import moment from 'moment';

import { HeadCountReportData, HeadCountReportMonthData } from '~/data/reports';

export type HeadCountMonth = {
  date: Date;
  month: string;
  employeeCount: number;
  leavers: number;
  joiners: number;
  netChange: number;
};

export type HeadCountYear = {
  date: Date;
  year: string;
  totalCounts: 4;
  monthlyCounts: HeadCountMonth[];
};

export const convertHeadCountReportDataMonthsToHeadCountMonths = (
  data: HeadCountReportMonthData[],
): HeadCountMonth[] => {
  const nextMonth = moment().add(1, 'month').startOf('month');

  return data
    .map((m) => {
      const { fEheDate, fEheLeavers, fEheJoiners, fEheCount } = m;
      const dateValue = moment(fEheDate, 'YYYY-MM-DD');

      return {
        date: dateValue.toDate(),
        month: dateValue.format('MM'),
        leavers: fEheLeavers,
        joiners: fEheJoiners,
        employeeCount: fEheCount,
        netChange: fEheJoiners - fEheLeavers,
      };
    })
    .filter((m) => moment(m.date).isBefore(nextMonth, 'month'));
};

export const convertHeadCountReportDataToHeadCountYears = (
  data: HeadCountReportData[],
): HeadCountYear[] => {
  return data.map((y): HeadCountYear => {
    const { fEhdDate, fEhdTotalCount, fEhdMonthlyCounts } = y;
    const dateValue = moment(fEhdDate, 'YYYY-MM-DD');

    return {
      date: dateValue.toDate(),
      year: dateValue.format('YYYY'),
      totalCounts: fEhdTotalCount,
      monthlyCounts:
        convertHeadCountReportDataMonthsToHeadCountMonths(fEhdMonthlyCounts),
    };
  });
};
